module.exports = __webpack_public_path__ + "static/img/counting.f9f0aee.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/counting.gif
// module id = r1EB
// module chunks = 1